import React from "react";
import {cloudRefiner} from "../../../../defaults/cloudMaker";
import {GridGistItem, isNarrow} from "./GridGistItem";
import styled from "@emotion/styled";

const Container = styled(`ol`)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 100%;
`;

const GridCloud = (props) => {
    let narrow = isNarrow(props.chapterWidth);
    let visibleCloud = cloudRefiner(props.cloud, narrow ? 9 : 15, 3);

    return <Container>{
        visibleCloud.map((cloudElement, idx) => (
            <GridGistItem
                key={idx}
                idx={idx}
                item={cloudElement}
                playWord={props.playWord}
                showWordOnTimeline={props.showWordOnTimeline}
                hideWordOnTimeline={props.hideWordOnTimeline}
                onHintTextShown={props.onHintTextShown}
                chapterWidth={props.chapterWidth}
                getGistPlayerRect={props.getGistPlayerRect}
                setLockGist={props.setLockGist}/>
        ))}
        <GridGistItem
            key={visibleCloud.length}
            idx={visibleCloud.length}
            item={props.nextElement}
            playWord={props.playWord}
            showWordOnTimeline={props.showWordOnTimeline}
            hideWordOnTimeline={props.hideWordOnTimeline}
            onHintTextShown={props.onHintTextShown}
            chapterWidth={props.chapterWidth}
            getGistPlayerRect={props.getGistPlayerRect}
            setLockGist={props.setLockGist}/>
    </Container>
}

export default GridCloud;